import React from 'react';
import { ChefHat, Landmark, Theater, GraduationCap, MapPin, Download, Radar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CategoryIcon = ({ cat }) => {
  switch (cat) {
    case 'restaurants': return <ChefHat size={16} />;
    case 'banks': return <Landmark size={16} />;
    case 'leisure': return <Theater size={16} />;
    case 'schools': return <GraduationCap size={16} />;
    default: return <MapPin size={16} />;
  }
};

const ScannerResult = ({ results, savedScanId, onExportPDF }) => {
  const navigate = useNavigate();
  if (!results) return null;

  const cats = {
    restaurants: 'Gastronomía',
    banks: 'Servicios/Bancos',
    leisure: 'Ocio/Comercio',
    schools: 'Educación',
    others: 'Otros POI'
  };

  const total = Object.values(results).reduce((acc, list) => acc + list.length, 0);

  return (
    <div style={{
      background: 'rgba(5, 7, 10, 0.9)',
      border: '1px solid var(--industrial-gray)',
      padding: '15px',
      borderRadius: '4px',
      maxHeight: '400px',
      overflowY: 'auto',
      fontSize: '13px',
      color: 'white',
      marginTop: '10px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        paddingBottom: '10px'
      }}>
        <h4 style={{ margin: 0, color: 'var(--tech-cyan)', fontSize: '12px' }}>
          SCAN RESULTS ({total})
        </h4>
        <div style={{ display: 'flex', gap: '10px' }}>
          {savedScanId && (
            <button 
              onClick={() => navigate(`/scan/${savedScanId}`)}
              style={{
                background: 'rgba(0, 240, 255, 0.1)',
                border: '1px solid var(--tech-cyan)',
                color: 'var(--tech-cyan)',
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                fontSize: '10px',
                fontWeight: 'bold'
              }}
            >
              <Radar size={12} /> MISSION REPORT
            </button>
          )}
          <button 
            onClick={onExportPDF}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--tech-cyan)',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              fontSize: '11px'
            }}
          >
            <Download size={14} /> PDF
          </button>
        </div>
      </div>

      {Object.entries(results).map(([cat, items]) => (
        items.length > 0 && (
          <div key={cat} style={{ marginBottom: '15px' }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px', 
              color: 'var(--tech-cyan)', 
              fontWeight: 'bold',
              fontSize: '11px',
              marginBottom: '8px',
              textTransform: 'uppercase'
            }}>
              <CategoryIcon cat={cat} />
              <span>{cats[cat]} ({items.length})</span>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              {items.slice(0, 5).map((item, idx) => (
                <div key={idx} style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '4px 8px',
                  background: 'rgba(255, 255, 255, 0.03)',
                  borderRadius: '2px',
                  fontSize: '11px'
                }}>
                  <span style={{ 
                    whiteSpace: 'nowrap', 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis',
                    maxWidth: '150px'
                  }}>
                    {item.name}
                  </span>
                  <span style={{ opacity: 0.6, fontFamily: 'monospace' }}>
                    {item.distance}m
                  </span>
                </div>
              ))}
              {items.length > 5 && (
                <div style={{ 
                  textAlign: 'right', 
                  fontSize: '10px', 
                  opacity: 0.4, 
                  fontStyle: 'italic',
                  paddingRight: '5px'
                }}>
                  + {items.length - 5} más...
                </div>
              )}
            </div>
          </div>
        )
      ))}
    </div>
  );
};

export default ScannerResult;
